
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.css';
import 'primeicons/primeicons.css';
import ReactDOM from 'react-dom';

import React, { Component } from 'react';
import { connect } from "react-redux";
import { Carousel } from 'primereact/carousel';
import { Button } from 'primereact/button';
import { SEND_RESPONSE } from './constants';

class CarouselCircular extends Component {

    constructor(props) {
        super(props);

        this.state = {
            products: [],
            title: ""
        };

        this.responsiveOptions = [
            {
                breakpoint: '1024px',
                numVisible: 2,
                numScroll: 2
            },
            {
                breakpoint: '800px',
                numVisible: 1,
                numScroll: 1
            },
            {
                breakpoint: '480px',
                numVisible: 1,
                numScroll: 1
            }

        ];

        this.productTemplate = this.productTemplate.bind(this);
    }

    componentDidMount() {
        this.setState({ products: this.props.options, title: this.props.title })
    }

    productTemplate(product) {
        const { sendResponse } = this.props;
        const actionResponse = {
            newMessage: '',
            conversationData: {
                agente: {
                    nombres: 'Chatbot'
                }
            },
            carousel: true
        }
        actionResponse.newMessage = product.value;
        return (
            <div className="product-item">
                <div className="product-item-content">
                    <div className="p-mb-3">
                        <img alt="Imagen ilustrativa del carrusel" title="Imagen ilustrativa del carrusel" src={`${product.image}`} onError={(e) => e.target.src = 'https://www.primefaces.org/wp-content/uploads/2020/05/placeholder.png'}  className="product-image" />
                    </div>
                    <div>
                        {/* <h4 className="p-mb-1">{product.label}</h4> */}
                        {/* <h6 className="p-mt-0 p-mb-3">${product.price}</h6>
                        <span className={`product-badge status-${product.inventoryStatus.toLowerCase()}`}>{product.inventoryStatus}</span> */}
                        <div className="car-buttons p-mt-5">
                            <Button aria-label="Realizar acción" title="Realizar acción" className="p-button p-button-rounded p-mr-2" onClick={() => sendResponse(actionResponse)}>{product.label}</Button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        return (
            <div className="carousel-demo">
                <div className="card">
                    <Carousel value={this.state.products}
                        numVisible={2}
                        numScroll={1}
                        responsiveOptions={this.responsiveOptions}
                        className="custom-carousel" circular
                        autoplayInterval={10000}
                        itemTemplate={this.productTemplate}
                        header={<h5>{this.state.title}</h5>}
                        showNavigators={true}
                        prevIcon="pi pi-chevron-left"   // ⬅️ flecha izquierda
                        nextIcon="pi pi-chevron-right"  // ➡️ flecha derecha
                    />
                </div>

            </div>
        );
    }
}
const mapStateToProps = state => {
    return {};
};

const mapDispachToProps = dispatch => {
    return {
        sendResponse: (value) => dispatch({ type: SEND_RESPONSE, value })
    };
};

export default connect(
    mapStateToProps,
    mapDispachToProps
)(CarouselCircular);


